const OKENDO_REVIEWS_SECTION = '[id$="__178633027944d0f544"]';
const MEDIA_SCALE = 2;
const DESKTOP_QUERY = window.matchMedia('(min-width: 750px)');

function configureCarousel(hooper) {
  const carousel = hooper.__vue__;

  if (!carousel || carousel.__sitoLayoutApplied || typeof carousel.updateTrim !== 'function') return;

  const updateTrim = carousel.updateTrim.bind(carousel);

  carousel.updateTrim = function updateSitoTrim() {
    updateTrim();

    if (!DESKTOP_QUERY.matches) return;

    this.config.infiniteScroll = false;
    this.config.trimWhiteSpace = false;
    this.trimStart = 0;
    this.trimEnd = Math.min(
      Math.max(1, Math.ceil(this.config.itemsToShow / MEDIA_SCALE)),
      this.slidesCount
    );
  };

  carousel.__sitoApplyLayout = function applySitoLayout() {
    this.update();
    this.$forceUpdate();
  };

  carousel.__sitoLayoutApplied = true;
  carousel.__sitoApplyLayout();
}

function initializeOkendoCarousels(root = document) {
  root
    .querySelectorAll(`${OKENDO_REVIEWS_SECTION} .oke-w-mediaCarouselModule .hooper`)
    .forEach(configureCarousel);
}

let initializationFrame;

function scheduleInitialization() {
  if (initializationFrame) return;

  initializationFrame = requestAnimationFrame(() => {
    initializationFrame = undefined;
    initializeOkendoCarousels();
  });
}

const observer = new MutationObserver(scheduleInitialization);

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
});

initializeOkendoCarousels();

document.addEventListener('shopify:section:load', scheduleInitialization);

DESKTOP_QUERY.addEventListener('change', () => {
  document
    .querySelectorAll(`${OKENDO_REVIEWS_SECTION} .oke-w-mediaCarouselModule .hooper`)
    .forEach((hooper) => hooper.__vue__?.__sitoApplyLayout?.());
});
